import { ToggleSkipConfirmationTypes } from "../nps-modal/nps-modal.types";
import {
  NpsThankyouAndSkipConfirmationScreenVariants,
  IUseNpsThankyouAndSkipConfirmationScreen,
  IUseNpsThankyouAndSkipConfirmationScreenProps
} from "./nps-thankyou-and-skip-confirmation.types";

export const useNpsThankyouScreen = ({
  toggleSkipConfirmation,
  handleModalClose
}: IUseNpsThankyouAndSkipConfirmationScreenProps): IUseNpsThankyouAndSkipConfirmationScreen => {
  const handleProceed = (
    variant:
      | NpsThankyouAndSkipConfirmationScreenVariants.SKIP_CONFIRMATION
      | NpsThankyouAndSkipConfirmationScreenVariants.SUBMIT_FEEDBACK
      | NpsThankyouAndSkipConfirmationScreenVariants.SUBMIT_PHONE_NUMBER
  ): void => {
    if (
      variant ===
        NpsThankyouAndSkipConfirmationScreenVariants.SUBMIT_FEEDBACK ||
      variant ===
        NpsThankyouAndSkipConfirmationScreenVariants.SUBMIT_PHONE_NUMBER
    )
      handleModalClose();
    else {
      toggleSkipConfirmation(
        ToggleSkipConfirmationTypes.SKIP_CONFIRMATION_SCREEN
      );
    }
  };

  const handleSeeYouLater = (): void => {
    handleModalClose();
  };

  return {
    handleProceed,
    handleSeeYouLater
  };
};
